import React, { Component } from 'react';
import { connect } from 'react-redux';
import { stringify, parse } from 'query-string';
import { get } from 'lodash';
import { bool, string, array, object } from 'prop-types';
import { setOffersCatalogFilter, resetOffersCatalogFilter } from '../../../actions/offers';
import { setStreamsFilter } from '../../../actions/streams';

import { OffersFilterView } from '../index';

const normalizeData = (data = [], skipParent = false) => {
  const result = [];

  if (data.length > 0) {
    for (let i = 0; i < data.length; i++) {
      const item = data[i];

      if (item.subParams && item.subParams.length > 0) {
        result.push(...normalizeData(item.subParams));

        if (skipParent) {
          return;
        }
      }

      item.checked > 0 && result.push(item.id);
    }
  }

  return result;
};

class OffersFilter extends Component {
  static propTypes = {
    items: array.isRequired,
    name: string.isRequired,
    defaultLabel: string.isRequired,
    activeFilters: object,
    selectedItems: array,
    search: bool,
    className: string,
  };

  static defaultProps = {
    items: [],
    selectedItems: [],
    search: false,
    className: '',
  };

  prepareParamsForURL = (params = {}) => {
    return Object.keys(params).reduce((parsed, key) => {
      const param = params[key];

      if (param !== undefined && Array.isArray(param)) {
        return { ...parsed, [key]: param.length > 0 ? param.join(',') : undefined };
      }

      return parsed;
    }, {});
  };

  setFiltersURL = params => {
    const parsed = this.prepareParamsForURL(params);
    const parsedParams = parse(window.location.search);
    if (parsedParams.search) {
      parsed.search = parsedParams.search;
    }

    history.replaceState(
      {},
      null,
      window.location.pathname + '?' + stringify(parsed, { encode: false }),
    );
  };

  onFilterChange = checked => {
    const { name, activeFilters } = this.props;
    const filter = { [name]: normalizeData(checked) };

    this.props.setOffersCatalogFilter(filter);

    this.setFiltersURL({
      ...activeFilters,
      ...filter,
    });
  };

  onFilterReset = () => {
    this.onFilterChange([]);
  };

  setItemStatus = (items, selectedItems) => {
    if (this.props.name === 'pixelGroups') {
      // selectedItems are strings after selecting; numbers when parsed from URL
      const selectedIds = selectedItems.map(item => parseInt(item));
      return items.map(item => ({
        ...item,
        checked: selectedIds.includes(parseInt(item.id.split(',')[0])),
        subParams: [],
      }));
    }
    return items.map(item => {
      return {
        ...item,
        checked: selectedItems.includes(item.id),
        subParams: item.subParams ? this.setItemStatus(item.subParams, selectedItems) : [],
      };
    });
  };

  getItems = () => {
    const { items, selectedItems } = this.props;
    return this.setItemStatus(items, selectedItems);
  };

  render() {
    const { name, search, defaultLabel, className, onUpdate, amount } = this.props;
    const items = this.getItems();
    const checkedItems = items.filter(el => el.checked).length;
    
    return (
      <OffersFilterView
        className={className}
        defaultLabel={defaultLabel}
        name={name}
        search={search}
        items={items}
        activeParamsNumber={checkedItems}
        onFilterChange={this.onFilterChange}
        onFilterReset={this.onFilterReset}
        normalizeData={normalizeData}
        onUpdate={onUpdate}
        amount={amount}
      />
    );
  }
}

const mapStateToProps = (state, props) => {
  const { inFlows, pathToState } = props;
  if (inFlows) {
    return {
      activeFilters: get(state, pathToState),
      selectedItems: get(state, pathToState)[props.name],
    };
  } else {
    return {
      activeFilters: state.offers.catalogFilters,
      selectedItems: state.offers.catalogFilters[props.name],
    };
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { inFlows } = ownProps;
  if (inFlows) {
    return {
      setOffersCatalogFilter: checked => dispatch(setStreamsFilter(checked)),
    };
  } else {
    return {
      setOffersCatalogFilter: checked => dispatch(setOffersCatalogFilter(checked)),
    };
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OffersFilter);
